var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7944 2.71331L6.51688 5.46331C0.952708 7.32415 0.952708 10.3583 6.51688 12.21L8.97354 13.0258L9.78938 15.4825C11.641 21.0466 14.6844 21.0466 16.536 15.4825L19.2952 7.21414C20.5235 3.50164 18.5069 1.47581 14.7944 2.71331ZM15.0877 7.64498L11.6044 11.1466C11.4669 11.2841 11.2927 11.3483 11.1185 11.3483C10.9444 11.3483 10.7702 11.2841 10.6327 11.1466C10.3669 10.8808 10.3669 10.4408 10.6327 10.175L14.116 6.67331C14.3819 6.40748 14.8219 6.40748 15.0877 6.67331C15.3535 6.93915 15.3535 7.37915 15.0877 7.64498Z",
    fill: "#0B101C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.c206614db3c0048d7fb1c743d0d41692.svg";
export { ForwardRef as ReactComponent };